import { useEffect, useRef } from 'react'

const useMountSafe = () => {
  const safe = useRef(true)
  
  useEffect(() => {
    safe.current = true;
    return () => {
      safe.current = false;
    }
  }, [])

  return safe
}

export default useMountSafe;